import Vue from 'vue';
export default Vue.extend({
    name: "UniqueFields",
    props: {
        settingIndex: { type: String, required: true },
        uniqueFields: { type: Array, default: () => [] },
    },
});
